function setRem() {
    const _screen = document.documentElement.clientWidth;
    if (_screen <= 768) {
        const baseSize = 16;
        const scale = _screen / 768;
        document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
    }else if(_screen < 1024){
        document.documentElement.style.fontSize = 10 + 'px';
    }else if(_screen < 1260){
        document.documentElement.style.fontSize = 10 + 'px';
    }else if(_screen < 1360){
        document.documentElement.style.fontSize = 11 + 'px';
    }else if(_screen < 1460){
        document.documentElement.style.fontSize = 12 + 'px';
    }else if(_screen < 1560){
        document.documentElement.style.fontSize = 13 + 'px';
    }
    else {
        const baseSize = 16;
        const scale = _screen / 1920;
        document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px';
        // document.documentElement.style.fontSize = 16 + 'px';
        // console.log(_screen,baseSize * Math.min(scale, 2) + 'px')
    }
}

setRem();

window.onresize = function() {
    setRem();
};
